/**
 * return prefixed number as percentage.
 *
 * @param  {string||integer} number number to format.
 * @return {string} modified string value.
 */
export default function getPrefixedNumberFormat(number) {
  let formattedValue = number;
  const valueIsString = 'string' === typeof number;
  const prefixChar = valueIsString ? number.charAt(0) : ''; // eslint-disable-line
  const isPrefixed = ['<', '>'].indexOf(prefixChar) > -1; // eslint-disable-line
  const suffixChars = isPrefixed ?
    number.slice(1, number.length) : number;

  // If our value is a string and prefixed (has < or >);
  if (valueIsString && isPrefixed) {
    // If our remainder (suffix) is less than itself, assume a decimal.
    // Convert to percentage and return value.
    if (suffixChars > Math.floor(suffixChars)) {
      formattedValue = `${prefixChar}${parseFloat(suffixChars) * 100}%`;
    } else {
      formattedValue = `${prefixChar}${parseFloat(suffixChars)}%`;
    }
  }
  // Return value.
  return formattedValue;
}



// WEBPACK FOOTER //
// ./app/utils/numeric/getPrefixedNumberFormat.js